module.exports = __webpack_public_path__ + "95b56622a30ff5e311d6974171118fde.png";